/**
 * A file the vendor stores, as a link the browser can load (MYP-96, MYP-116).
 *
 * The vendor sends two kinds of path for its images: site-relative ones like
 * `/Public/Uploads/2023-12-24/…png` — on the same host as the API, so `origin` is the API's own
 * origin, passed in by the app rather than assumed here — and full URLs on an image service
 * (`https://ik.imagekit.io/…`), which are used as they are. Encoded either way, so a space or
 * quote in a path cannot break a link or a CSS `url()`.
 */
export function vendorAssetUrl(path: string, origin: string): string {
  const url = /^https?:\/\//i.test(path)
    ? path
    : `${origin.replace(/\/+$/, '')}${path.startsWith('/') ? '' : '/'}${path}`;
  return encodeURI(url);
}
